import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAtomValue } from 'jotai';
import useFirstRender from '@src/hooks/utils/useFirstRender';
import { persistAtoms } from '@src/store/trends/base/actions';
import { persistenceAtom } from '@components/ActionToolbar/atoms';

// workaround to have persistence for atom state
// this is until we migrate persistence flow
// at least avoids us having to add new redux state

export default function usePersistAtoms({ bindSelector }) {
  const dispatch = useDispatch();
  const first = useFirstRender();
  const atomStateToPersist = useAtomValue(persistenceAtom);

  useEffect(() => {
    bindSelector.getAtomState = () => ({ ...atomStateToPersist });

    // do not re-render based on `first`
    if (!first) {
      dispatch(persistAtoms());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [atomStateToPersist]);
}
